import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import {
  GiftMessageApiInputs,
  GiftMessageApiResults,
  GiftPlan,
} from 'frontend/types/premium/gifts';
import { apiResolve } from 'frontend/router';
import { postData } from 'frontend/utils/ajax';

interface GiftPlansState {
  annual_plan: GiftPlan;
  lifetime_plan?: GiftPlan;
  one_month_plan?: GiftPlan;
}

const giftPlans: Module<GiftPlansState, RootState> = {
  namespaced: true,
  state: {} as GiftPlansState,
  mutations: {
    setValue(state: GiftPlansState, value: GiftPlansState): void {
      Object.assign(state, value);
    },
  },

  actions: {
    async saveGiftMessage({}, data: GiftMessageApiInputs): Promise<GiftMessageApiResults> {
      const url = apiResolve({ name: 'gift_purchase_message_save' }).href;
      try {
        const response = await postData(url, data);
        if (response.results?.errors) {
          return {
            errors: {
              form_errors: [],
              field_errors: response.results.errors.field_errors,
            },
          };
        }
        return { gift_checkout_info: response.results.gift_checkout_info };
      } catch (e) {
        const status = e.response && e.response?.status ? e.response.status : 'unknown error';
        return {
          errors: {
            form_errors: [`We encountered an error while processing your request. (${status})`],
          },
        };
      }
    },
  },

  getters: {
    annualGiftPlan: (state: GiftPlansState) => state.annual_plan,
    lifetimeGiftPlan: (state: GiftPlansState) => state.lifetime_plan,
    oneMonthGiftPlan: (state: GiftPlansState) => state.one_month_plan,
  },
};

export default giftPlans;
